import MainContainer from "../../components/container/MainContainer";

const PDOReports = () => {
  return <MainContainer>PDOReports</MainContainer>;
};

export default PDOReports;
